import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Alert from './components/Alert/AlertDialog';
import Layout from './components/layout/Layout';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/*" element={<Layout />} />
            </Routes>
            <Alert />
        </BrowserRouter>
    );
}

export default App;
